import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, useResolvedPath } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.css";
import Header from "./Header";
import MainContent from "./MainContent";
import Footer from "./Footer";
import "./styles.css";
import { linkTrackEvent, pageTrackEvent } from "../services/analyticsService";

function Welcome() {
  const navigate = useNavigate();
  const location = useLocation();
  const resolved = useResolvedPath("./accountholder");
  const [group, setGroup] = useState("");
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const group_num = params.get("group");
    if (group_num) {
      setGroup(group_num);
    }
  }, [location.search]);

   useEffect(() => {

       pageTrackEvent({
               experienceType: "desktop",
               is404:  false,
               lang: "english",
               name: "enrollment",
               sitesection1: "public",
               sitesection2: "health-savings-accounts",
               sitesection3: "resources",
               sitesection4: "open-hsa",
               test: "",
               group: "",
               referringSite: "",
               customAttributes: {}
           }
       );

   }, []);


  const handleNextClick: any = () => {
      const to = group
          ? `${resolved.pathname}?group=${group}`
          : resolved.pathname;
      const fullUrl = new URL(to, window.location.origin).href;
      linkTrackEvent("next", "open hsa form", "internal", fullUrl);
      navigate(to);
  };


  return (
    <>
      <Header />
      <div className="container-fluid update">
        <MainContent handleNextClick={handleNextClick} />
        <Footer />
      </div>
    </>
  );
}

export default Welcome;
